import React from 'react'
import { Container, Row, Col, Label, Input, Button } from 'reactstrap'
import '../../css/PopOverController.css'
import { Account } from '../../model/Account'
import NumberTextField from '../../view/NumberTextField'
import { downloadPackageSlip } from '../../model/request/pdf'

class PackagingSlipModalController extends React.Component{

    constructor(props) {
        super(props)

        this.state = {
            packaging_slip: this.props.quote.job_name,
            quantities: [],
            notes: '',
        }
    }

    downloadPackageSlip() {
        downloadPackageSlip(
            this.props.quote,
            this.state.quantities,
            this.state.packaging_slip,
            this.state.notes
        )
    }

    render() {
        const account = Account.fromCookieAndLocalStorage()
        if (this.state.quantities.length !== this.props.quote.signs.length) {
            this.setState((state) => {
                return {
                    'quantities': this.props.quote.signs.map((sign) => {
                        return sign.quantity
                    }),
                }
            })
        }
        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '20px',
                            'fontWeight': '500',
                        }}
                            >{'PO # / Job Name'}</Label>
                        <Input
                            value={this.state.packaging_slip}
                            onChange={(e) => {
                                this.setState({
                                    'packaging_slip': e.target.value
                                })
                            }} />
                    </Col>
                </Row>
                <Row><Col>
                    <Row>
                        <Col sm={4}>
                            <Label>Type</Label>
                        </Col>
                        <Col sm={4}>
                            <Label>Process</Label>
                        </Col>
                        <Col sm={4}>
                            <Label>Quantity</Label>
                        </Col>
                    </Row>
                    {this.props.quote.signs.map((sign, index) => {
                        return <Row>
                            <Col sm={4}>
                                <Label>{sign.given_id}</Label>
                            </Col>
                            <Col sm={4}>
                                <Label>{sign.type.label}</Label>
                            </Col>
                            <Col sm={4}>
                                <NumberTextField
                                    showDigitsKeyPad={account.settings.numbers_calculator_show}
                                    style={{
                                        'textAlign': 'right',
                                    }}
                                    value={this.state.quantities[index]}
                                    onChange={(e) => {
                                        this.setState((state) => {
                                            state.quantities[index] = e.target.value
                                            return {
                                                'quantities': this.state.quantities
                                            }
                                        })
                                    }}/>
                            </Col>
                        </Row>
                    })}
                </Col></Row>
                <Row style={{'marginTop': '8px'}}>
                    <Col>
                        <Label>Message</Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Input
                            type="textarea"
                            style={{'width': '100%', 'minHeight': '115px'}}
                            onChange={(e) => this.setState({
                                'notes': e.target.value
                            })}
                            value={this.state.notes} />
                    </Col>
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px'
                        }}
                            color='primary' onClick={(e) => this.downloadPackageSlip()}>Download</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { PackagingSlipModalController }

